import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { HistoryLogTemplate } from 'themes/components';

function ReceivingHistoryLogListTemplate({ receivingHistoryLogViewStore }) {
	const { listStore } = receivingHistoryLogViewStore;
	return <HistoryLogTemplate listStore={listStore}></HistoryLogTemplate>;
}

export default defaultTemplate(ReceivingHistoryLogListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/receiving/pages/ReceivingHistoryLogListTemplate.jsx